import { render, staticRenderFns } from "./UserTicketsView.vue?vue&type=template&id=f2a5a7ce&scoped=true"
import script from "./UserTicketsView.vue?vue&type=script&lang=js"
export * from "./UserTicketsView.vue?vue&type=script&lang=js"
import style0 from "./UserTicketsView.vue?vue&type=style&index=0&id=f2a5a7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a5a7ce",
  null
  
)

export default component.exports